import React from 'react'
import ReactSelect from 'react-select'
import ReactSelectGrayStyle from '../../common/ReactSelectGrayStyle'
import useOptionDropdownStyles from './useOptionDropdownStyles'

export const MenuItemSelectorComponent = (props) => {
    const [ valueState, setValueState ] = React.useState(props.value)
    const [ onOpen, setOnOpen ] = React.useState(false)
    
    const {options, placeholder, isDisabled, handleOptionClick} = props

    const IndicatorSeparator = () => null

    const classes = useOptionDropdownStyles()

    React.useEffect(() => {
        if (props.value) {
            setValueState(options.find(f => f.value === props.value))
        }
    }, [props.value, options])

    React.useEffect(()=>{
        if (props.selectedValues && props.selectedValues.length > 0 && !onOpen) {
            setValueState(options.find(f => props.selectedValues.some(s => s.value === f.value)))
            setOnOpen(true)
        }
    },[props.selectedValues])

    return <div className={classes.itemSelector} >
            <ReactSelect
                onChange={valueObj => {
                    setValueState(valueObj)
                    handleOptionClick({...valueObj, selectorId: props.id})
                }}
                value={valueState}
                options={options}
                styles={ReactSelectGrayStyle}
                components={{ IndicatorSeparator }}
                placeholder={placeholder}
                noOptionsMessage={() => 'No hay opciones'}
                isDisabled={isDisabled}
            />
    </div>
}
